// extracted by mini-css-extract-plugin
export default {"LoadError":"bft_a big_qs big_a big_w big_j big_q","LoadError__icon":"bft_b big_vl big_fm big_sw","LoadError__message":"bft_c big_fm big_tr"};